import { BundleRoute } from '@/components/bundle-route';
import { Loader } from '@/components/loader';
import EventContext from '@/js/site/context/EventContext';
import { LiveForum } from '@/pages/live/forum';
import { LiveRoom } from '@/pages/live/live-room';
import { Session } from '@/pages/live/session';
import { UserMonitorContextProvider } from '@/user-monitor';
import { Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AuthWall } from '../shared/components/AuthWall';
import { AuthContext } from '../shared/context/AuthContext';
import MessageContextProvider from '../shared/context/MessageContext';
import PollContext from '../shared/context/PollContext';
import RoomContext from '../shared/context/RoomContext';
import Participants from '../site/components/dashboards/Participants';
import EntityListDashboard from './components/dashboards/EntityListDashboard';
import EntitySlideShow from './components/dashboards/EntitySlideShow';
import EntityViewFullscreen from './components/dashboards/EntityViewFullscreen';
import Expo from './components/dashboards/Expo';
// import { StudioBackstage } from './components/dashboards/StudioBackstage';
import PollEmbed from './components/interact/PollEmbed';
import { DiscussionImageDashboard } from './components/views/DiscussionImageDashboard';
import { MingleLarge } from './components/dashboards/MingleLarge';
import { ConferenceContext } from '../shared/context/ConferenceContext';
import C from '../../../shared/constants/general';

const Reception = React.lazy(() => import('@/pages/live/reception'));

export const LiveRoutes = () => {
  const { authState } = useContext(AuthContext);
  const { conferenceState, welcomeState } = useContext(ConferenceContext);

  const baseName = '/live';

  return authState.stateLoaded && conferenceState.conferenceDetail ? (
    <AuthWall>
      <UserMonitorContextProvider>
        <Router>
          {welcomeState ? (
            <Route
              path={`${baseName}`}
              render={(props) => (
                <React.Suspense fallback={<Loader />}>
                  <Reception {...props} state="welcome" />
                </React.Suspense>
              )}
            />
          ) : (
            <Switch>
              <Route
                exact
                path={`${baseName}`}
                render={(props) => (
                  <React.Suspense fallback={<Loader />}>
                    <Reception {...props} />
                  </React.Suspense>
                )}
              />
              <Route
                exact
                path={`${baseName}/poll`}
                render={(props) => (
                  <PollEmbed
                    conferencename={window.CONFERENCE_NAME}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/discussion`}
                render={(props) => <LiveForum {...props} />}
              />
              <Route
                exact
                path={`${baseName}/discussionimages/:discussionId`}
                render={(props) => (
                  <DiscussionImageDashboard
                    discussionId={props.match.params.discussionId}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/discussion/:topic`}
                render={(props) => <LiveForum {...props} />}
              />
              <Route
                exact
                path={`${baseName}/participants`}
                render={(props) => <Participants {...props} />}
              />
              <Route
                exact
                path={`${baseName}/expo`}
                render={(props) => <Expo {...props} />}
              />
              <Route
                path={`${baseName}/meet`}
                render={(props) => <MingleLarge {...props} />}
              />

              {/* <Route
              exact
              path={`${baseName}/backstage`}
              render={(props) => <StudioBackstage {...props} />}
            /> */}
              <Route
                exact
                path={`${baseName}/item/:entityId`}
                render={(props) => (
                  <EntityViewFullscreen
                    entityId={props.match.params.entityId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/item/:entityId/slideshow`}
                render={(props) => (
                  <EntitySlideShow
                    entityId={props.match.params.entityId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/list/:entityListId`}
                render={(props) => (
                  <EntityListDashboard
                    entityListId={props.match.params.entityListId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/list/:entityListId/item/:entityId`}
                render={(props) => (
                  <EntityViewFullscreen
                    entityId={props.match.params.entityId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/list/:entityListId/item/:entityId/slideshow`}
                render={(props) => (
                  <EntitySlideShow
                    entityId={props.match.params.entityId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${baseName}/room/:roomId`}
                render={(props) => (
                  <RoomContext>
                    <PollContext>
                      <MessageContextProvider>
                        <LiveRoom user={authState.user} {...props} />
                      </MessageContextProvider>
                    </PollContext>
                  </RoomContext>
                )}
              />
              <Route
                exact
                path={`${baseName}/session/room/:roomId`}
                render={(props) => (
                  <EventContext>
                    <PollContext>
                      <Session
                        conferencename={window.CONFERENCE_NAME}
                        {...props}
                      />
                    </PollContext>
                  </EventContext>
                )}
              />
              <Route
                exact
                path={`${baseName}/session/:eventId`}
                render={(props) => (
                  <EventContext>
                    <PollContext>
                      <Session
                        conferencename={window.CONFERENCE_NAME}
                        {...props}
                      />
                    </PollContext>
                  </EventContext>
                )}
              />

              <BundleRoute bundle="live" />
            </Switch>
          )}
        </Router>
      </UserMonitorContextProvider>
    </AuthWall>
  ) : (
    <Box align="center">
      <CircularProgress disableShrink />
    </Box>
  );
};
